import { inicialNome } from '@/lib/os-tabela';

/** Avatar (foto real ou iniciais) + nome, no padrão DS `.tbl-name`/`.tbl-avt`. */
export function PessoaCell({ nome, avatarUrl }: { nome: string; avatarUrl?: string | null }) {
  return (
    <span className="tbl-name">
      <span className="tbl-avt" aria-hidden>
        {avatarUrl ? <img src={avatarUrl} alt="" /> : inicialNome(nome)}
      </span>
      <span className="tbl-name__nm">{nome}</span>
    </span>
  );
}
